import HttpClient from "HttpClient";
import apiRoutes from "../../Routes/Routes.json";

const getAssayData = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.OncologyCompendium.AssayData.getAssayData}`,
    queryModel
  );
};
const createOrUpdateAssayData = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.OncologyCompendium.AssayData.createOrUpdateAssayData}`,
    queryModel
  );
};

export const AOEsAssayNameLookup = (queryModel: any) => {
  return HttpClient().post(
    `/${apiRoutes.OncologyCompendium.AssayData.AOEsAssayNameLookup}`,
    queryModel
  );
};
const ReferenceLabsLookup = () => {
  return HttpClient().get(
    `/${apiRoutes.OncologyCompendium.AssayData.reference_labs_lookup}`
  );
};
const GetPanelsAndReportingRulesById = (id: any) => {
  return HttpClient().get(
    `/${apiRoutes.OncologyCompendium.AssayData.GetPanelsAndReportingRulesById}/${id}`
  );
};

const AssayDataService = {
  getAssayData,
  createOrUpdateAssayData,
  ReferenceLabsLookup,
  GetPanelsAndReportingRulesById,
};

export default AssayDataService;
